<template>
  <div class="program-title">
    <span class="program-title__prefix">{{ prefix }}</span>
    <a :href="link" target="_blank" class="program-title__title">{{ title }}</a>
    <span class="program-title__suffix">{{ suffix }}</span>
  </div>
</template>

<script>
export default {
  name: "ProgramTitle",
  props: {
    prefix: {
      type: String,
      default: "",
      required: true
    },
    suffix: {
      type: String,
      default: "",
      required: true
    },
    title: {
      type: String,
      default: undefined,
      required: true
    },
    link: {
      type: String,
      default: "#",
      required: false
    }
  }
};
</script>

<style lang="scss" scoped>
.program-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  &__prefix,
  &__suffix {
    align-items: center;
    color: theme-color("body");
    display: inline-flex;
    font-size: px-to-rem(21px);
    text-align: center;

    @include if-tablet {
      font-size: px-to-rem(40px);
    }
  }

  &__title {
    color: theme-color("body");
    font-size: px-to-rem(36px);
    font-weight: 700;
    text-align: center;
    max-width: 1200px;
    transition: cta-transition(transform);

    @include if-tablet {
      font-size: px-to-rem(60px);
    }

    @include if-desktop {
      font-size: px-to-rem(80px);
    }

    &:hover {
      transform: scale(1.05);
    }

    &:not(:hover) {
      animation: titleAttention 2s 1s infinite forwards ease;
    }

    @keyframes titleAttention {
      0% {
        transform: scale(1);
      }
      40% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.06);
      }
      75% {
        transform: scale(1);
      }
      100% {
        transform: scale(1);
      }
    }
  }
}
</style>
